module.exports = __webpack_public_path__ + "img/E2 UB2.62f66900.png";